import React from 'react';
import PropTypes from 'prop-types';

/**
 * Page - A wrapper that renders a standard HTML li with Bulma class names
 *
 * This component accepts the same props as Bloomer Page for easy migration
 */
const Page = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = [];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <li className={getClassNames()} style={style} {...props}>
      {children}
    </li>
  );
};

Page.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

Page.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default Page;
